import {Component, OnDestroy, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {Location} from "@angular/common";
import {Subscription} from "rxjs";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";

import {AppService, getStepRoute, Host, Menu} from "../../../../../common";
import {Cart, DiscountEntry} from "../../../../../common";
import {DiscountConditionType, OrderMethod} from "../../../../../common";

@Component({
  selector: 'choose-method',
  standalone: false,
  templateUrl: './choose-method.html',
  styleUrls: ['./choose-method.scss']
})
export class ChooseMethodPage implements OnInit, OnDestroy {

  host: Host;
  menu: Menu;
  cart: Cart;
  OrderMethod = OrderMethod;
  form: FormGroup;
  takeout_discounts: Array<DiscountEntry>;
  delivery_discounts: Array<DiscountEntry>;

  private subscriptions: Array<Subscription> = new Array<Subscription>();

  constructor(
      private router: Router,
      private location: Location,
      private appService: AppService,
      private formBuilder: FormBuilder,
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
        this.appService.load().subscribe(({host, menu, cart}) => {
          this.host = host;
          this.menu = menu;
          this.cart = cart;
          if (this.cart.positions.length == 0) {
            this.router.navigate(['/'])
          }
          // init the form
          this.form = this.formBuilder.group({
            address: [this.cart.address.address, Validators.minLength(4)],
            city: [this.cart.address.city, [Validators.required]]
          });
          // if the host has delivery but not takeout, set the method accordingly
          if (this.host.has_delivery && !this.host.has_takeout) {
            this.cart.method = OrderMethod.delivery;
            this.cart.save();
          }
          // build a list of discounts which apply to delivery method, and wrap them into
          // DiscountEntry instances.
          const total = this.cart.getNetTotal();  // needed to calculate amount for discount
          this.takeout_discounts =
            host.discounts
              .filter(d => d.appliesTo(DiscountConditionType.OrderMethod, OrderMethod.takeout))
              .map(d => new DiscountEntry(this.cart, d, d.getAmount(this.cart, total), 0));
          this.delivery_discounts =
            host.discounts
              .filter(d => d.appliesTo(DiscountConditionType.OrderMethod, OrderMethod.delivery))
              .map(d => new DiscountEntry(this.cart, d, d.getAmount(this.cart, total), 0));
          // subscribe to form changes
          this.subscriptions.push(
              this.form.valueChanges.subscribe((value) => {
                if (this.form.valid) {
                  this.cart.address.address = value.address;
                  this.cart.address.city = value.city;
                }
              })
          );
        })
    );
  }

  ngOnDestroy(): void {
    let sub = null;
    while(sub = this.subscriptions.pop()) {
      sub.unsubscribe();
    }
  }

  showModeSelection() {
    return this.host.has_takeout && this.host.has_delivery;
  }

  showAddressEntry() {
    return this.cart.method == OrderMethod.delivery;
  }

  formValid() {
    return (this.cart.method == OrderMethod.takeout) || this.form.valid;
  }

  canProceed() {
    return this.cart.getMethodIsValid()
           && this.formValid()
           && this.cart.checkMinOrderAmount().valid
           && this.appService.getOrdersEnabled();
  }

  onFormSubmit() {
    if (this.form.valid) {
      this.cart.address.address = this.form.value.address;
      this.cart.address.city = this.form.value.city;
      this.next();
    }
  }

  back() {
    this.location.back()
  }

  setMode(method: OrderMethod) {
    this.cart.setMethod(method);
    return false;
  }

  getNextStep() {
    return this.cart.getNextCheckoutStep();
  }

  next() {
    if (this.canProceed()) {
      this.cart.save();
      this.router.navigate(getStepRoute(this.getNextStep()))
    }
  }
}
